import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function isEffectiveRole(user, allowed) {
  if (!user || !allowed) return true;
  if (allowed.includes(user.role)) return true;
  // Front Office Manager con delega temporanea RM è trattato come RM
  if (
    user.role === "front_office_manager" &&
    user.temp_resident_manager === true &&
    allowed.includes("resident_manager")
  ) {
    return true;
  }
  return false;
}

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex h-screen w-screen items-center justify-center ih-bg-ambient">
        <div className="flex flex-col items-center gap-3 text-muted-foreground">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span className="text-sm">Caricamento…</span>
        </div>
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  if (roles && !isEffectiveRole(user, roles)) {
    return <Navigate to="/" replace />;
  }
  return children;
}

export { isEffectiveRole };
